import React from 'react';
import moment from 'moment';

import {
    Card,
    Row,
    Col,
    Table,
    Popover,
    Button,
} from 'antd';

import VmSelector from './selector';

import {
    _getVmProducts,
    _getVmSales,
} from '../../../services'

class VmViewer extends React.Component {

    constructor(props) {
        super(props) 
        this.state = {
            activeVm: '',
            vmProducts: [],
            vmSales: [],
        }
    }

    render() {
        return (
            <Card>
                <VmSelector
                    onSelect={this.handleVmSelected} />

                <Row gutter={8}>
                    <Col span={14}>
                        {this.renderVmProductsTable()}
                    </Col>
                    <Col span={10}>
                        {this.renderVmSalesTable()}
                    </Col>
                </Row>
            </Card>
        )
    }

    getVmProducts = () => {
        _getVmProducts({dataOrigin: this.state.activeVm})
        .then(_vmProducts => {
            this.setState({
                vmProducts: _vmProducts.data
            })
        })
    }

    getVmSales = () => {
        _getVmSales({
            dataOrigin: this.state.activeVm, 
            startDate: moment().subtract(1,'month').toDate(),
            endDate: moment().toDate()
        })
        .then(_vmSales => {
            this.setState({
                vmSales: _vmSales.data
            })
        })
    }

    renderVmProductsTable = () => {

        const columns = [{
            title: 'Image',
            dataIndex: 'product.images',
            render: (images, record) => <img src={record.product.images[0].url} style={{width: 50, height: 50}} />
        },{
            title: 'Title',
            dataIndex: 'product.title'
        },{
            title: 'Qty',
            dataIndex: 'count'
        },{
            title: 'Tags',
            dataIndex: 'tags',
            render: (tags) => this.renderTagsPopover(tags)
        }]

        return (
            <Table 
                columns={columns}
                dataSource={this.state.vmProducts}
                pagination={false}
                />
        )
    }

    renderVmSalesTable = () => {

        const columns = [{
            title: 'refNumber',
            dataIndex: 'cart.refNumber',
            render: (refNumber, record) => (record.cart && record.cart.refNumber ) || '-'
        },{
            title: 'Check Out Date',
            dataIndex: 'cart.chceckOutDate',
            render: (chceckOutDate, record) => (record.cart && moment(record.cart.chceckOutDate).format('LLL') ) || '-'
        }]

        return (
            <Table 
                columns={columns}
                dataSource={this.state.vmSales}
                pagination={false}
                expandedRowRender={(record) => this.renderExpandedRow(record.cart)}
                />
        )

    }

    renderExpandedRow = (cart) => {
        const columns = [{
            title: 'Image',
            dataIndex: 'product.images',
            render: (images, record) => <img src={record.product.images[0].url} style={{width: 50, height: 50}} />
        },{
            title: 'Title',
            dataIndex: 'product.title'
        },{
            title: 'Qty',
            dataIndex: 'quantity'
        }]

        return (
            <Table 
                columns={columns}
                dataSource={cart.products || []}
                pagination={false}
                />
        )
    }

    renderTagsPopover = (tags) => {

        var content;

        if (tags) {
            content = <ul>
                {tags.map(_tag => <li>{_tag}</li>)}
            </ul>
        }

        return (
            <Popover content={content} title="Tag List">
                <Button type="primary">Tags</Button>
            </Popover>
        )
    }

    handleVmSelected = (value) => {
        this.setState({
            activeVm: value
        }, () => {
            this.getVmProducts()
            this.getVmSales()
        })
    }

}

export default VmViewer


// WEBPACK FOOTER //
// ./src/components/vm/viewer/index.js